module.exports = __webpack_public_path__ + "static/ogimage-2541c688ab29abe4e4c78e654e930ac0.jpg";